import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/WhyChooseUs/WhyChooseUs.js
const WhyChooseUs = createSectionForm({
  icon: "thumb-up-line",
  title: "Why Choose Us",
  fields: [
    { name: "title", label: "Section Title" },
    { name: "show_description", label: "Show Descriptions", type: "switch" },
    {
      name: "items",
      label: "Reasons",
      type: "list",
      itemLabel: "Reason",
      fields: [
        { name: "image", label: "Icon", type: "media" },
        { name: "name", label: "Title" },
        { name: "description", label: "Description", type: "richtext", height: 90 },
      ],
    },
  ],
});

export default WhyChooseUs;
